import '@fontsource/roboto';
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueResource from 'vue-resource';
import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import VueI18Next from '@panter/vue-i18next';
import VueObserveVisibility from 'vue-observe-visibility';
import App from './App.vue';
import router from './router';
import * as moment from 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-10-year-range';
import VueAuth from '@websanova/vue-auth';
import VueAuthHttp from '@websanova/vue-auth/drivers/http/vue-resource.1.x';
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import vuetify from './plugins/vuetify';
import store from './store';
import './registerServiceWorker';

Vue.config.productionTip = false;
Vue.use(VueI18Next);
Vue.use(VueResource);
Vue.use(VueObserveVisibility);
Vue.use(VueCookies);

Vue.$cookies.config('90d');

Vue.router = router;
// Vue.http.options.root = 'http://localhost:8080';
Vue.http.options.root = 'https://api.toursol.at';

Vue.prototype.globalEvents = new Vue();
moment.locale('de');
moment.tz.setDefault('Europe/Vienna');
Vue.prototype.$moment = moment;
Vue.filter('date', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('DD.MM.YYYY');
});

Vue.filter('year', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('YYYY');
});

Vue.filter('dayMonth', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('DD.MM');
});

Vue.filter('day', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('ddd');
});

Vue.filter('dayFull', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('dddd');
});

Vue.filter('dateTime', (date) => {
  if (date === undefined || date === null) {
    return '';
  }
  return moment(date).tz('Europe/Vienna').format('DD.MM.YYYY hh:mm:ss');
});

Vue.filter('price', (price) => {
  if (price === undefined || price === null) {
    return '';
  } else if (price === 0) {
    return 0;
  }
  let formattedPrice = price / 100; //CONVERT PRICE FROM CENTS
  if (formattedPrice % 1 !== 0) {
    formattedPrice = Number(formattedPrice).toFixed(2);
  }
  return formattedPrice;
});

i18next
  .use(XHR)
  .init({
    fallbackLng: 'DE',
    lng: store.getters.getLanguage,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}.json',
    },
  });

const i18n = new VueI18Next(i18next);

Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {Authorization: token});
    },
    response: function (res) {
      /* if (!res.ok) {
        localStorage.removeItem('toursol_token');
        window.location.href = '/login';
      } */
      const headers = this.options.http._getHeaders.call(this, res);
      return headers.Authorization || headers.authorization;
    }
  },
  http: VueAuthHttp,
  router: VueAuthRouter,
  rolesVar: 'role',
  parseUserData: (data) => {
    data.role = data.authority.name;
    delete data.authority;
    data.email = data.username;
    return data;
  },
  tokenDefaultName: 'toursol_token',
  forbiddenRedirect: '/login'
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  Vue.prototype.globalEvents = new Vue();
});
new Vue({
  vuetify: vuetify,
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
